import React from "react";

import classNames from "classnames";
import { capitalize } from "lodash";
import { Col, Form, Row } from "react-bootstrap";
import Select from "react-select";

import { useFiltersContext } from "../contexts/Filters";
import { Filters as RatingsFilters } from "../types/ratings";

import useBreakpoint from "../../../../../../hooks/useBreakpoint";
import { isXOrSmaller } from "../../../../../../lib/utils";

const Filters = React.memo(() => {
    const { filters, setFilters } = useFiltersContext();
    const breakpoint = useBreakpoint();
    const categories: Array<keyof RatingsFilters> = [
        "attitude",
        "consistency",
        "effort",
        "overall",
    ];
    const ratingsOptions = [5, 4, 3, 2, 1];

    return (
        <>
            <Row className={classNames("umpireRatingsFilters")}>
                <Col
                    xs={6}
                    lg={4}
                    xl={2}
                    className={classNames({
                        col: true,
                        "mt-2": isXOrSmaller("md", breakpoint),
                    })}
                >
                    <h6>Umpire:</h6>
                    <Form.Control
                        type="text"
                        name="umpire"
                        value={filters.umpire || ""}
                        onChange={e =>
                            setFilters(prev => ({
                                ...prev,
                                umpire: e.target.value,
                            }))
                        }
                    />
                </Col>
                <Col
                    xs={6}
                    lg={4}
                    xl={2}
                    className={classNames({
                        col: true,
                        "mt-2": isXOrSmaller("md", breakpoint),
                    })}
                >
                    <h6>Min. Number of Ratings:</h6>
                    <Form.Control
                        type="text"
                        name="count"
                        value={filters.count || ""}
                        onChange={e =>
                            setFilters(prev => ({
                                ...prev,
                                count: parseInt(e.target.value),
                            }))
                        }
                    />
                </Col>
                {categories.map(c => (
                    <Col
                        xs={6}
                        lg={4}
                        xl={2}
                        key={c}
                        className={classNames("col")}
                    >
                        <h6>{capitalize(c)}</h6>
                        <Select
                            isSearchable={false}
                            isClearable={true}
                            isMulti={false}
                            options={ratingsOptions.map(r => ({
                                value: r,
                                label: r,
                            }))}
                            value={
                                filters[c]
                                    ? {
                                          value: filters[c],
                                          label: filters[c],
                                      }
                                    : null
                            }
                            onChange={r => {
                                setFilters(prev => ({
                                    ...prev,
                                    [c]: r?.value,
                                }));
                            }}
                        />
                    </Col>
                ))}
                <Col>
                    <small>
                        Ratings filters will filter by max rating value (ie. 3
                        will filter any ratings up to a max of 3)
                    </small>
                </Col>
            </Row>
        </>
    );
});

export default Filters;
